import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';
import * as fromAppointments from '@app/my-zone/pages/claims/store/actions/appointments.actions';
import * as fromClaims from '@app/my-zone/pages/claims/store/actions/claims.actions';
import { ClaimAppointmentInterface } from '@app/my-zone/pages/claims/store/entity/appointment.interface';
import { ClaimEventInterface } from '@app/my-zone/pages/claims/store/entity/claim-event.interface';
import * as fromRoot from '@app/store/app.reducer';
import { Store } from '@ngrx/store';
import { Notification } from 'outshared-lib';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'ins-appointment-booking-container',
    template: `
        <ins-appointment-booking
            [appointment]="appointment"
            [fileSerialNumber]="file_serial_number"
            [notifications]="notifications$ | async"
            [loading]="loading$ | async"
            (submitted)="onSubmit($event)"
        >
        </ins-appointment-booking>
    `,
})
export class AppointmentBookingContainer {
    @Input() appointment: ClaimAppointmentInterface;
    @Input() file_serial_number: number;
    public notifications$: Observable<Notification[]> = this.store.select(fromMyClaims.getSelectedAppointmentErrors);
    public loading$: Observable<boolean> = this.store.select(fromMyClaims.isAppointmentsLoading);
    private subscriptions = new Subscription();

    constructor(
        private store: Store<fromRoot.State>,
        private route: ActivatedRoute,
    ) {}

    public onSubmit(payloads: {
        clearErrorPayload: {}, setAppointmentPayload: {
            adres_relatie_id: number,
            schadeherstel_gebeurtenis: any[],
            dossier_volgnummer: number,
            netwerk_id: string,
            claim_volgnummer: number,
            gebeurtenis: ClaimEventInterface,
            schadeherstel_soort_vervangend_vervoer_code: string,
        },
    }): void {
        this.store.dispatch(new fromAppointments.ClearErrors(payloads.clearErrorPayload));
        this.store.dispatch(new fromAppointments.Set(payloads.setAppointmentPayload));

        // Timeout is needed to insure load action is not performed to early
        setTimeout(() => {
            this.subscriptions.add(
                this.route
                    .queryParams
                    .subscribe((params) =>
                        this.store.dispatch(new fromClaims.LoadActions({ dossier_volgnummer: params.d }))),
            );
        }, 5000);
    }
}
